import { TAccountButtonType, TAccountSectionType } from "../../models/account";
import { EButtonBooking, EButtonUserPage } from "../../models/common/enums";

export const handleNavigationAccount =
    (btnType: "booking" | "user") =>
    (
        id: TAccountButtonType,
        sectionTypeData: TAccountSectionType
    ): TAccountSectionType => {
        if (btnType === "booking") {
            if (id === EButtonBooking.YOURBOOKING) {
                return {
                    title: "Your Bookings",
                    sectionType: id,
                    tourId: "",
                };
            }
            if (id === EButtonBooking.PERSONALINFO) {
                return {
                    ...sectionTypeData,
                    title: "General Info",
                    sectionType: id,
                };
            }
            if (id === EButtonBooking.PAYMENTS) {
                return {
                    ...sectionTypeData,
                    title: "Payments",
                    sectionType: id,
                };
            }

            return {
                title: "",
                sectionType: EButtonBooking.YOURBOOKING,
                tourId: "",
            };
        }

        if (id === EButtonUserPage.YOURACCOUNT) {
            return {
                title: "Your Account",
                sectionType: id,
            };
        }
        if (id === EButtonUserPage.PERSONALINFOUSERPAGE) {
            return {
                ...sectionTypeData,
                title: "Personal Info",
                sectionType: id,
            };
        }
        if (id === EButtonUserPage.PAYMENTSUSERPAGE) {
            return {
                ...sectionTypeData,
                title: "Payment methods",
                sectionType: id,
            };
        }
        if (id === EButtonUserPage.LOGINANDSECURITY) {
            return {
                ...sectionTypeData,
                title: "Login and Security",
                sectionType: id,
            };
        }
        if (id === EButtonUserPage.NOTIFICATIONS) {
            return {
                ...sectionTypeData,
                title: "Privacy",
                sectionType: id,
            };
        }

        return {
            title: "Your Account",
            sectionType: EButtonUserPage.YOURACCOUNT,
        };
    };
